import { Box, FontAwesomeIcon } from "@skailer-com/uikit";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

interface RecognitionBadgeTemplate {
  title: string;
  badge_url: string | null;
  system_icon_code?: string | null;
}

type RecognitionBadgeSize = "3xs" | "2xs" | "xs" | "sm" | "md" | "lg";

interface RecognitionBadgeProps {
  template: RecognitionBadgeTemplate;
  size?: RecognitionBadgeSize;
}

const sizeClasses: Record<RecognitionBadgeSize, string> = {
  "3xs": "w-5 h-5",
  "2xs": "w-8 h-8",
  xs: "w-9 h-9",
  sm: "w-16 h-16",
  md: "w-41 h-41",
  lg: "w-57 h-57",
};

const iconClasses: Record<RecognitionBadgeSize, string> = {
  "3xs": "text-xs",
  "2xs": "text-sm",
  xs: "text-base",
  sm: "text-2xl",
  md: "text-4xl",
  lg: "text-6xl",
};

const radiusClasses: Record<RecognitionBadgeSize, string> = {
  "3xs": "rounded-xs",
  "2xs": "rounded-sm",
  xs: "rounded-sm",
  sm: "rounded-sm",
  md: "rounded-sm",
  lg: "rounded-sm",
};

export function RecognitionBadge({ template, size = "md" }: RecognitionBadgeProps) {
  const [errored, setErrored] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const src =
    template.badge_url ??
    (template.system_icon_code ? `/recognition-badges/${template.system_icon_code}` : null);

  if (!src || errored) {
    return (
      <Box
        className={`${sizeClasses[size]} ${radiusClasses[size]} shrink-0 overflow-hidden bg-dark/5 flex items-center justify-center text-secondary`}
      >
        <FontAwesomeIcon icon={"fa-light fa-award"} className={iconClasses[size]} />
      </Box>
    );
  }

  return (
    <Box
      className={`${sizeClasses[size]} ${radiusClasses[size]} shrink-0 overflow-hidden bg-dark/5`}
    >
      <img
        src={src}
        alt={template.title}
        onError={() => setErrored(true)}
        onLoad={() => setIsLoaded(true)}
        className={twMerge(
          "w-full h-full object-cover transition-opacity duration-200",
          isLoaded ? "opacity-100" : "opacity-0"
        )}
      />
    </Box>
  );
}
